export const TOGGLE_PLANET_DETAILS_PANE = "d";
export const TOGGLE_PLANET_ARTIFACTS_PANE = "a";
export const TOGGLE_DIAGNOSTICS_PANE = "p";
